import { getApiCall } from "../utils/servicesBaseUtil";
import { catchErrors } from "../utils/catchErrors";
import { REFERRAL_HISTORY } from "../constants/url";

export const getReferralHistoryApi = ({ successCallback, finalCallback }) => {
  return (dispatch) => {
    let url = REFERRAL_HISTORY;
    getApiCall({ url: url })
      .then((responseJson) => {
        if (responseJson?.success) {
          successCallback(responseJson);
        }
      })
      .catch((error) => {
        catchErrors(error, url);
      })
      .finally(() => {
        finalCallback();
      });
  };
};
